import { useFormContext } from 'react-hook-form';

import { RangeNumericRubric, RUBRIC_TYPES } from '../../Datatable.types';

export const useFilterRange = ({
  filter,
  onChange,
}: {
  filter: RangeNumericRubric;
  onChange: (selectedFilter: RangeNumericRubric) => void;
}) => {
  const defaultMin =
    filter.facets?.length === 0
      ? 0
      : Number(
          filter.facets?.reduce((prev, current) =>
            Number(prev.key) < Number(current.key) ? prev : current,
          ).key,
        );
  const defaultMax =
    filter.facets?.length === 0
      ? 100
      : Number(
          filter.facets?.reduce((prev, current) =>
            Number(prev.key) > Number(current.key) ? prev : current,
          ).key,
        );

  const { getValues, clearErrors } = useFormContext();

  const onChangeRangeMin = () => {
    const value = getValues(`filterStartRangeNumeric_${filter.name}`);
    let searchValue = value;

    if (value !== undefined) {
      if (defaultMin !== undefined && value < defaultMin) {
        searchValue = defaultMin;
      }
      if (defaultMax !== undefined && value > defaultMax) {
        searchValue = defaultMax;
      }
    }

    const maxValue = getValues(`filterEndRangeNumeric_${filter.name}`);

    if (
      searchValue !== undefined &&
      maxValue !== undefined &&
      searchValue > maxValue
    ) {
      return;
    }
    clearErrors([
      `filterStartRangeNumeric_${filter.name}`,
      `filterEndRangeNumeric_${filter.name}`,
    ]);

    onChange({
      name: filter.name,
      label: filter.label,
      maxValue,
      minValue: searchValue,
      type: RUBRIC_TYPES.RANGE_NUMERIC,
      filterName: `filterStartRangeNumeric_${filter.name}`,
    });
  };

  const onChangeRangeMax = () => {
    const value = getValues(`filterEndRangeNumeric_${filter.name}`);
    let searchValue = value;

    if (value !== undefined) {
      if (defaultMin !== undefined && value < defaultMin) {
        searchValue = defaultMin;
      }
      if (defaultMax !== undefined && value > defaultMax) {
        searchValue = defaultMax;
      }
    }

    const minValue = getValues(`filterStartRangeNumeric_${filter.name}`);

    if (
      searchValue !== undefined &&
      minValue !== undefined &&
      searchValue < minValue
    ) {
      return;
    }
    clearErrors([
      `filterStartRangeNumeric_${filter.name}`,
      `filterEndRangeNumeric_${filter.name}`,
    ]);

    onChange({
      name: filter.name,
      label: filter.label,
      maxValue: searchValue,
      minValue,
      type: RUBRIC_TYPES.RANGE_NUMERIC,
      filterName: `filterEndRangeNumeric_${filter.name}`,
    });
  };

  return {
    defaultMin,
    defaultMax,
    min:
      getValues(`filterStartRangeNumeric_${filter.name}`) === ''
        ? undefined
        : getValues(`filterStartRangeNumeric_${filter.name}`),
    max:
      getValues(`filterEndRangeNumeric_${filter.name}`) === ''
        ? undefined
        : getValues(`filterEndRangeNumeric_${filter.name}`),
    onChangeRangeMin,
    onChangeRangeMax,
  };
};
